<div class="p-flex-col-xl p-py-md p-px-lg action-content">
  <header class="p-flex-col-xs">
    <div class="p-flex-row-xs p-flex-center-y">
      <span class="p-text-title-sm p-color-text-primary">Dataset ready to be used</span>
      @if (rowCount) {
      <p-tag-md level="highlight">{{ rowCount | number }} documents</p-tag-md>
      }
    </div>
    <span class="p-text-body p-color-text-secondary">
      Your dataset is processed and indexed. Explore it, track models trained on it, or start training a new one.
    </span>
  </header>

  <section class="p-flex-col-sm">
    <span class="p-text-title-sm p-color-text-secondary">Explore &amp; analyze</span>
    <div class="action-grid">
      @if (exploreExists()) {
      <app-ingest-action-card
        icon="compass"
        title="Explore with AI"
        description="Ask questions and surface themes in this dataset using LLMs and other models, no setup needed."
        actionLabel="Explore dataset"
        [disabled]="!canExplore()"
        [loading]="isSendingToExplore"
        [disabledReason]="exploreReason()"
        (action)="sendToExplore()"
      />
      } @if (analysisExists()) {
      <app-ingest-action-card
        icon="dashboard"
        title="View live dashboard"
        description="Track performance and usage of fingerprint models already deployed from this dataset, in real time."
        actionLabel="View dashboard"
        [disabled]="!canDashboard()"
        [loading]="isDashboarding"
        [disabledReason]="dashboardReason()"
        (action)="dashboard()"
      />
      }
      <app-ingest-action-card
        icon="analytics"
        title="Visualize fingerprint"
        description="Run a data set analysis with an existing model to see how your documents cluster and compare."
        actionLabel="Visualize models"
        [disabled]="!canUnitAnalyze()"
        [loading]="isUnitAnalyzing"
        [disabledReason]="unitAnalysisReason()"
        (action)="unitAnalyze()"
      />
    </div>
  </section>

  <section class="p-flex-col-sm">
    <span class="p-text-title-sm p-color-text-secondary">Train a model</span>
    <div class="action-grid">
      <app-ingest-action-card
        icon="fingerprint"
        title="Fingerprint model"
        description="Assign every document a unique topic score automatically. Fastest way to get structure with no manual work."
        actionLabel="Train fingerprint model"
        [disabled]="!canFingerprint()"
        [loading]="isFingerprinting"
        [disabledReason]="fingerprintReason()"
        (action)="trainFPModel()"
      />
      <app-ingest-action-card
        icon="bookmark"
        title="Manual annotation"
        description="Label documents yourself, guided by the fingerprint model's suggestions, to build a training set."
        actionLabel="Annotate documents"
        [disabled]="!canAnnotate()"
        [loading]="isAnnotating"
        [disabledReason]="annotateReason()"
        (action)="annotateData()"
      />
      @if (isDeepLearningEnabled$ | async) {
      <app-ingest-action-card
        icon="graph_deep_learning"
        title="Deep learning model"
        description="Train a supervised model on your labelled documents for the highest accuracy on your own categories."
        actionLabel="Train deep learning model"
        [disabled]="!canDL()"
        [loading]="isDeepLearning"
        [disabledReason]="deepLearningReason()"
        (action)="trainDLModel()"
      />
      }
    </div>
  </section>
</div>
